import { Person, ResponseError } from '@ynap/api-utils';
import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR } from '../constants/ActionTypes';
import { timeout, delay } from '@ynap/promise-utils';

function resetPasswordRequest() {
    return {
        type: RESET_PASSWORD_REQUEST,
    };
}

function resetPasswordSuccess() {
    return {
        type: RESET_PASSWORD_SUCCESS,
    };
}

function resetPasswordError(error) {
    return {
        type: RESET_PASSWORD_ERROR,
        error,
    };
}

export default function resetPassword(credentials, requestDelay) {
    return (dispatch, getState, fetch) => {
        const { locale, config } = getState();
        const { country } = locale;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const { validationCode, ...rest } = credentials;

        const user = {
            ...rest,
            resetPassword: 'true',
            xcred_logonPasswordVerify: rest.logonPassword,
            xcred_validationCode: encodeURIComponent(validationCode),
        };

        const request = Person.userUpdate({ baseUrl, brandId, country, user, clientId, clientSecret });

        dispatch(resetPasswordRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), requestDelay || clientRequest.delay)
            .then((response) => {
                if (response.ok) {
                    return dispatch(resetPasswordSuccess());
                }
                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(resetPasswordError(error));
                throw error;
            });
    };
}
